import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import useLenis from "@/lib/useLenis";
import { AuthProvider } from "@/lib/auth";

import Header from "@/components/pnp/Header";
import Hero from "@/components/pnp/Hero";
import Marquee from "@/components/pnp/Marquee";
import Manifesto from "@/components/pnp/Manifesto";
import Services from "@/components/pnp/Services";
import Gallery from "@/components/pnp/Gallery";
import Contact from "@/components/pnp/Contact";
import Footer from "@/components/pnp/Footer";
import FloatingWhatsApp from "@/components/pnp/FloatingWhatsApp";

import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";
import Kundenbereich from "@/pages/Kundenbereich";
import AuthCallback from "@/pages/AuthCallback";

function Home() {
  useLenis();
  return (
    <main className="App relative bg-white">
      <Header />
      <Hero />
      <Marquee />
      <Manifesto />
      <Services />
      <Gallery />
      <Contact />
      <Footer />
      <FloatingWhatsApp />
    </main>
  );
}

// Detect session_id in URL fragment synchronously before regular routes render.
// This prevents any race with AuthProvider or ProtectedRoute logic.
function AppRouter() {
  const location = useLocation();
  if (location.hash && location.hash.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/impressum" element={<Impressum />} />
      <Route path="/datenschutz" element={<Datenschutz />} />
      <Route path="/kundenbereich" element={<Kundenbereich />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Toaster
          position="top-center"
          richColors
          toastOptions={{
            style: {
              fontFamily: "'Manrope', sans-serif",
              borderRadius: 12,
            },
          }}
        />
      </AuthProvider>
    </BrowserRouter>
  );
}
